import { GatsbyImage } from 'gatsby-plugin-image';
import { useContext } from 'react';

import { Container, Section } from 'components/GridV2';
import CustomPortableText from 'components/rebrand/CustomPortableText';
import { GetKOHOBtn } from 'components/rebrand/GetKOHOBtn';
import { LocaleContext } from 'components/rebrand/Layout';

import { IHero } from 'typescriptDefs/pages/new-to-canada';

import { afTrackingByPage } from 'helpers/getAfTracking';

type Props = {
  deeplink?: string | null;
  pageName: string;
} & IHero;

const Hero = ({ ctaText, deeplink, heading, image, pageName, subheading }: Props) => {
  const locale = useContext(LocaleContext);
  return (
    <Section className="bg-white pb-64 pt-40 md:pb-96 md:pt-64">
      <Container className="px-32 text-center xs:px-0">
        <div className="mx-auto [&_h1]:text-primary-350 [&_h1_strong]:text-primary-200">
          <CustomPortableText content={heading} />
        </div>
        <div className="mb-32 w-full md:mb-48 [&_p]:mx-auto md:[&_p]:w-2/5">
          <CustomPortableText
            content={subheading}
            headingStyles={{
              h1: { as: 'h2', className: 'text-primary-350 [&_strong]:text-primary-200 mb-16 md:mb-24' },
            }}
          />
        </div>
        <GetKOHOBtn
          className="mx-auto mb-64 block"
          buttonLocation={`${pageName} Hero`}
          queryParams={afTrackingByPage('NEWTOCANADA')}
          trackEventProps={{
            category: pageName,
            label: `${pageName} Hero`,
            locale,
          }}
          to={deeplink || undefined}
        >
          {ctaText}
        </GetKOHOBtn>
        {image && (
          <GatsbyImage
            className="mx-auto block h-388 max-w-312 rounded-24 md:h-612 md:max-w-490 md:rounded-16"
            alt={image.altText}
            image={image.img.asset.gatsbyImageData}
          />
        )}
      </Container>
    </Section>
  );
};

export default Hero;
